__turbopack_context__.v({
  "SoftwareCard": "Vs53fW_SoftwareCard",
  "SoftwareCard__Button": "Vs53fW_SoftwareCard__Button",
  "SoftwareCard__ButtonText": "Vs53fW_SoftwareCard__ButtonText",
  "SoftwareCard__Container": "Vs53fW_SoftwareCard__Container",
  "SoftwareCard__Content": "Vs53fW_SoftwareCard__Content",
  "SoftwareCard__ImageWrapper": "Vs53fW_SoftwareCard__ImageWrapper",
  "SoftwareCard__Split": "Vs53fW_SoftwareCard__Split",
  "SoftwareCard__Tag": "Vs53fW_SoftwareCard__Tag",
  "SoftwareCard__Text": "Vs53fW_SoftwareCard__Text",
  "SoftwareCard__Title": "Vs53fW_SoftwareCard__Title",
});
